export default __webpack_public_path__ + "static/media/livesign-cloud-secure.031a8389.png";